import React, { createRef } from "react";
import BaseElem from "../BaseElem";
import "./LocationInput.css";
import "../Common.css";
import { InputField } from "./InputField";
import { Button } from "@material-ui/core";
import { SUBURB_STATE_POSTCODE_API, UNDEF } from "../Constants";
import { TextDropdown } from "./TextDropdown";
import { VisitLocationAddress } from "../@types/PricingModels";
import { isAU, isMY } from "../DataConstants";
import Api from "../Api";
export const AU_CITIES = [
  { name: "Melbourne", id: "RqLvjBS6L" },
  { name: "Sydney", id: "7ebXqJmuw37sAs7ow" },
  { name: "Brisbane", id: "pPXBRu4JyomEgZbK5" },
];
type LocationInputProps = {
  location?: VisitLocationAddress;

  // disable all inputs for readonly state
  readOnly?: boolean;

  // disable user interaction
  disabled?: boolean;

  multiLine?: boolean;
  showApplyAll?: boolean;
  maxLines?: number;
  inpClassName?: string;
  doneBtnText?: string;
  showAsPopup?: boolean;

  style?: any;
  fieldsStyle?: any;

  onChange?: Function;
  states: any[];
  //locationFields: any[];
};

type LocationInputState = {
  _haveFocus?: boolean;

  state?: string;
  city?: string;
  district?: string;
  suburbValue?: string | undefined;
  suburbData?: any;
};

export function getLocationText(
  location?: VisitLocationAddress,
  state?: LocationInputState
): string {
  if (!location) return "";

  const val = (v?: string, sep = ", ") => (!v ? "" : v + sep);
  if (isAU)
    return (
      val(location.unit_number) +
      val(location.street_number, " ") +
      val(location.street_address) +
      val(location.city) +
      val(location.suburb) +
      val(location.state) +
      val(location.post_code) +
      val(location.country, "")
    );
  return (
    val(location.block_number, " ") +
    val(location.street_address) +
    val(location.unit_number) +
    val(location.post_code, " ") +
    val(location.district) +
    val(location.city, " ") +
    val(location.state) +
    val(location.country, "")
  );
}

export class LocationInput extends BaseElem<
  LocationInputProps,
  LocationInputState
> {
  _fieldNames = [
    "block_number",
    "street_address",
    "unit_number",
    "post_code",
    "street_number",
    //'district',
    //'state',
    "country",
  ];

  _refs = {
    block_number: createRef<HTMLInputElement>(),
    street_address: createRef<HTMLInputElement>(),
    unit_number: createRef<HTMLInputElement>(),
    street_number: createRef<HTMLInputElement>(),
    post_code: createRef<HTMLInputElement>(),
    country: createRef<HTMLInputElement>(),
  };
  _textfieldRef = createRef<InputField>();

  constructor(props: LocationInputProps) {
    super(props);
    this.state = {
      _haveFocus: false,
      city: undefined,
    };
  }

  _loadValues() {
    const self = this;
    const location: any = self.props.location;
    if (!location) return;

    const fieldNames = self._fieldNames;
    const refs: any = self._refs;
    for (let i = fieldNames.length; i--; ) {
      const field = refs[fieldNames[i]].current;
      field && (field.value = location[fieldNames[i]] || "");
    }
    self.setState({
      city: location.city ?? AU_CITIES[0].id,
      district: location.district,
      state: location.state,
      suburbValue: location.suburb
        ? location.suburb + ", " + location.state + ", " + location.post_code
        : "",
    });
  }

  _setFocus(haveFocus = true) {
    const self = this;
    self.setState({
      _haveFocus: haveFocus,
    });
    haveFocus && self.async(() => self._loadValues());
    return true;
  }
  _gainFocus = () => {
    this._setFocus(true);
  };
  _loseFocus = () => {
    this._setFocus(false);
  };

  blur() {
    const self = this;
    self._textfieldRef.current?.blur();
    self._setFocus(false);
  }

  _save(isApplyAll = false) {
    const self = this;
    const fieldNames = self._fieldNames;
    const updatedLocation: any = {};
    const refs: any = self._refs;
    for (let i = fieldNames.length; i--; ) {
      const field = refs[fieldNames[i]].current;
      field && (updatedLocation[fieldNames[i]] = field.value);
    }
    updatedLocation.state = self.state.state;
    if (isAU) {
      const [suburb, state, post_code] =
        self.state.suburbValue?.split(", ") || []; //comma with space--important
      updatedLocation.suburb = suburb;
      updatedLocation.state = state;
      updatedLocation.post_code = post_code;
      updatedLocation.city = self.state.city;
    }
    updatedLocation.district = self.state.district;
    const fn = !self.props.readOnly && self.props.onChange;
    fn && fn(updatedLocation, isApplyAll);
    self.blur();
  }

  _setAddrState(addrState: any) {
    const self = this,
      state = self.state;

    if (!addrState || !addrState.name) {
      self.setState({ state: UNDEF, district: UNDEF });
      return;
    }

    const district = (addrState.districts || []).find(
      (d: string) => d === state.district
    );
    self.setState({
      state: addrState.name,
      district: district,
    });
  }
  onFocus = () => {
    const { suburbValue } = this.state;
    if (!suburbValue) {
      Api.GET(
        SUBURB_STATE_POSTCODE_API, //hardcoded for now as we have only Melborune city
        ({ data }: any) => {
          this.setState({
            suburbData: data?.data?.suburb_state_postcode ?? [],
          });
        },
        false,
        true,
        true
      );
    }
  };
  _renderFields() {
    const self = this,
      props = self.props,
      state = self.state;
    const isReadOnly = props.readOnly,
      isPopup = props.showAsPopup;
    const states = props.states || [];
    const stateDistWidth = isPopup ? "28%" : "21%";

    const refs = self._refs;

    return (
      <div
        className={"li-fields v "}
        is-popup={isPopup ? "" : UNDEF}
        style={props.fieldsStyle}
      >
        {isAU ? (
          <>
            <div className="h">
              <input
                ref={refs["unit_number"]}
                placeholder="Unit No. /Building Name"
                type="text"
                style={{ width: "32%" }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
              <input
                ref={refs["street_number"]}
                placeholder="Street No."
                type="text"
                style={{ width: "29%" }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
              <input
                ref={refs["street_address"]}
                placeholder="Street Name"
                type="text"
                style={{ flexGrow: 1 }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
            </div>
            <div className="h">
              <div
                className="h center pi-row"
                style={{ width: isPopup ? "62%" : "54%" }}
              >
                <TextDropdown
                  style={{ width: "100%" }}
                  useVirtualList
                  itemHeight={40}
                  width="100%"
                  filterSelection
                  popupWidth="270px"
                  popupMaxHeight="300px"
                  placeholder="Suburb/ State/ Postcode"
                  hideFocusBar
                  onFocus={self.onFocus}
                  readOnly={isReadOnly}
                  popupDisabled={isReadOnly}
                  showDropdownArrow
                  items={state.suburbData ?? []}
                  selectedItem={state.suburbValue}
                  onChange={(_: any, item: any) =>
                    self.setState({ suburbValue: item })
                  }
                />
              </div>
              <TextDropdown
                style={{ width: isPopup ? "38%" : "21%", fontSize: "inherit" }}
                width="100%"
                titleProperty="name"
                placeholder="City"
                showDropdownArrow
                items={AU_CITIES}
                hideFocusBar
                popupMaxHeight="300px"
                selectedItem={state.city}
                readOnly={isReadOnly}
                popupDisabled={isReadOnly}
                onChange={(_: any, city: any) =>
                  state.city !== city &&
                  self.setState({ city, suburbValue: "" })
                }
              />
              {!isPopup && (
                <input
                  ref={refs["country"]}
                  type="text"
                  readOnly={true}
                  style={{ width: "21%" }}
                />
              )}
              {!isPopup && (
                <Button
                  size="small"
                  className="li-save-btn"
                  onClick={() => self._save()}
                >
                  {isReadOnly ? "Close" : "Save"}
                </Button>
              )}
            </div>
            <div>
              {isPopup && (
                <input ref={refs["country"]} type="text" readOnly={true} />
              )}
            </div>
          </>
        ) : (
          <>
            <div className="h">
              <input
                ref={refs["block_number"]}
                placeholder="Building No."
                type="text"
                style={{ width: "20%" }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
              <input
                ref={refs["street_address"]}
                placeholder="Street"
                type="text"
                style={{ flexGrow: 1 }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
              <input
                ref={refs["unit_number"]}
                placeholder="Unit"
                type="text"
                style={{ width: "14%" }}
                readOnly={isReadOnly}
                autoComplete="s"
              />
            </div>

            <div className="h">
              <input
                ref={refs["post_code"]}
                placeholder="Postal Code"
                type="text"
                style={{ width: "20%", flexShrink: 0 }}
                readOnly={isReadOnly}
                autoComplete="s"
              />

              {isMY && (
                <TextDropdown
                  hideFocusBar
                  style={{ width: stateDistWidth, fontSize: "inherit" }}
                  width="100%"
                  titleProperty="name"
                  placeholder="State"
                  items={states}
                  selectedItem={state.state}
                  readOnly={isReadOnly}
                  showDropdownArrow
                  popupDisabled={isReadOnly}
                  onChange={(_: any, state: any) => self._setAddrState(state)}
                />
              )}

              {isMY && (
                <TextDropdown
                  hideFocusBar
                  style={{ width: stateDistWidth, fontSize: "inherit" }}
                  inputClassName={
                    state.state && !state.district ? "li-error" : UNDEF
                  }
                  width="100%"
                  titleProperty="name"
                  placeholder="Area"
                  items={
                    (states.find((s) => s.name === state.state) || {})
                      .districts || []
                  }
                  popupMaxHeight="300px"
                  showDropdownArrow
                  selectedItem={state.district}
                  readOnly={isReadOnly}
                  popupDisabled={isReadOnly}
                  onChange={(_: any, district: any) =>
                    self.setState({ district: district })
                  }
                />
              )}

              <input
                ref={refs["country"]}
                type="text"
                readOnly={true}
                style={{ width: isMY ? "96px" : "" }}
              />

              {!isPopup && (
                <Button
                  size="small"
                  className="li-save-btn"
                  onClick={() => self._save()}
                >
                  {isReadOnly ? "Close" : "Save"}
                </Button>
              )}
            </div>
          </>
        )}
        {isPopup && !isReadOnly && (
          <div className="li-bottom-bar">
            {props.showApplyAll && (
              <Button
                tabIndex={0}
                className="ha-dialog-done li-done-all"
                onClick={() => self._save(true)}
              >
                Apply to selected visits
              </Button>
            )}

            <Button
              tabIndex={0}
              color="primary"
              className="ha-btn-green li-done"
              variant="contained"
              onClick={() => self._save()}
            >
              {props.doneBtnText || "Save"}
            </Button>
          </div>
        )}
      </div>
    );
  }

  render() {
    const self = this,
      props = self.props,
      location = (props.location || {}) as VisitLocationAddress;
    return (
      <div className="li-root" style={props.style}>
        <InputField
          ref={self._textfieldRef}
          type="text"
          inpClassName={props.inpClassName}
          text={getLocationText(location, self.state)}
          hideFocusBar={!!props.readOnly}
          readOnly
          inlineExpand
          manualBlur
          multiLine={props.multiLine}
          maxLines={props.maxLines}
          disabled={props.disabled}
          placeholder="Enter Location"
          blurOnTabKey={false}
          onFocus={self._gainFocus}
          onBlur={self._loseFocus}
          width="100%"
        >
          {props.showAsPopup && self.state._haveFocus && self._renderFields()}
        </InputField>

        {!props.showAsPopup && self._renderFields()}
      </div>
    );
  }
}
